/**
 * General Services class
 */
import RestClient from '../Client/RestClient'
import CookiesStorageService from '../CookiesStorageService'
import { NamedRoutes } from '../../routes'
import Configuration from '../Api/Configuration'
import { formatRoute } from 'react-router-named-routes'
import { filterData } from '../../utils/helpers'
import notificationTypes from '../../configurations/notification-types'
import notificationChannels from '../../configurations/notification-channels'
import moment from 'moment'

let { Admin_EndPoints } = Configuration

class ListingServices {
  static getListingData(entity, params, defaultErrorMessage = '', codeType, returnError, noNotification, default401ErrorMessage = '') {
    let config = {}
    if (!!params && !!Object.keys(params).length) {
      config['params'] = params
    }
    let endPoint = Admin_EndPoints[entity]

    // TODO: Format these lines to be in only one object, and move it to the payload functions
    if (entity === "notification") {
      if (params?.ReceiverType === undefined || params?.ReceiverType !== 3) {
        endPoint = Admin_EndPoints['SPnotification']
        let data = {
          correlation_Id: "e390a1a2-23b8-4592-983d-1625e08f91ab",
          pageNo: params.pageNo - 1,
          pageSize: params.pageSize,
          status: 3,
          receiverType: params?.ReceiverType || 1
        }

        if (!!params?.DateFrom) {
          data['dateFrom'] = moment(params?.DateFrom).locale('en-us').format('YYYY-MM-DD')
        }
        if (!!params?.DateTo) {
          data['dateTo'] = moment(params?.DateTo).locale('en-us').format('YYYY-MM-DD')
        }
        if (!!params?.NotificationId) {
          data['notificationId'] = params?.NotificationId
        }

        if (!!params?.Type) {
          data['types'] = notificationTypes.filter((i) => i.id.toString() === params.Type.toString())[0].sp_lookup
        }

        if (!!params?.Channel) {
          data['channel'] = notificationChannels.filter((i) => i.id.toString() === params.Channel.toString())[0].sp_id
        }


        return RestClient.getPostRequest(endPoint, data, defaultErrorMessage, returnError, noNotification, null, default401ErrorMessage)

      }else{
        if (!!params.Type) {
          params['Type'] = notificationTypes.filter((i) => i.id.toString() === params.Type.toString())[0].ms_lookup
        }
        if (!!params.DateFrom) {
          params['DateFrom'] = moment(params.DateFrom).locale("en-us").utc().format()
        }
        if (!!params.DateTo) {
          params['DateTo'] = moment(params.DateTo).locale("en-us").utc().format()
        }
      }
    }

    if (!!codeType) {
      if (codeType === 'EGS') {
        endPoint += `/codes/my`
        config['params'] = {
          ...config['params'],
          ...filterData({
            CodeTypeID: 9,
            ItemCode: !!config['params'].CodeLookupValue ? `EG-${config['params'].CodeLookupValue}` : null,
            SubmitExpiredCode: true
          })
        }
      } else {
        endPoint += `/${codeType}/codes`
      }
    }
    return RestClient.getRequest(endPoint, config, defaultErrorMessage, returnError, noNotification, null, default401ErrorMessage)
  }

  static getInvoicesListingData(params, defaultErrorMessage = '') {
    let config = {}
    // let config = { headers: { 'Authorization': `Bearer ${CookiesStorageService.getAccessToken()}` } }
    if (!!params && !!Object.keys(params).length) {
      config['params'] = params
    }
    return RestClient.getRequest(Admin_EndPoints.invoices.recent, config, defaultErrorMessage)
  }

  static getEInvoicesListingData(params, defaultErrorMessage = '', default401ErrorMessage = '') {
    let config = {}
    // let config = { headers: { 'Authorization': `Bearer ${CookiesStorageService.getAccessToken()}` } }
    if (!!params && !!Object.keys(params).length) {
      config['params'] = params
    }
    return RestClient.getRequest(Admin_EndPoints.invoices.msRecent, config, defaultErrorMessage, false, false, null, default401ErrorMessage)
  }


  static signInvoices(data, setFormLoading, FormikActions, defaultErrorMessage = '') {
    return RestClient.postRequest(Admin_EndPoints.invoices.signing, data, null, setFormLoading, null, null, defaultErrorMessage)
  }

  static submitInvoices(data, config = null, setFormLoading, FormikActions, defaultErrorMessage = '') {
    return RestClient.postRequest(Admin_EndPoints.invoices.submit, data, config, setFormLoading, null, null, defaultErrorMessage)
  }

  static SaveInvoiceEntity(data, entityType, setFormLoading, FormikActions, defaultErrorMessage = '') {
    return RestClient.postRequest((entityType === 'template') ? Admin_EndPoints.saveTemplate : Admin_EndPoints.saveDraft, data, null, setFormLoading, null, FormikActions, defaultErrorMessage)
  }

  static getInvoiceDownloadData(type, id, setProgress, defaultErrorMessage = '', default404ErrorMessage = '') {
    if (!!id) {
      let config = {
        // responseType: 'blob', // important
        onDownloadProgress: (progressEvent) => {
          !!setProgress && setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total)) // you can use this to show user percentage of file downloaded
        }
      }
      if (['download-pdf', 'print'].includes(type)) {
        config.responseType = 'blob'
      }
      return RestClient.getRequest(Admin_EndPoints.invoices.actions.download + `/${id}/${['download-pdf', 'print'].includes(type) ? 'pdf' : 'raw'}`, config, defaultErrorMessage, false, false, default404ErrorMessage)
    }
  }

  static getMsInvoiceDownloadData(type, id, setProgress, defaultErrorMessage = '', default404ErrorMessage = '') {
    if (!!id) {
      let config = {
        // responseType: 'blob', // important
        onDownloadProgress: (progressEvent) => {
          setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total)) // you can use this to show user percentage of file downloaded
        }
      }
      if (['download-pdf', 'print'].includes(type)) {
        config.responseType = 'blob'
      }
      return RestClient.getRequest(Admin_EndPoints.invoices.actions.download + `/${id}/${['download-pdf', 'print'].includes(type) ? 'pdf' : 'raw'}/einvoice`, config, defaultErrorMessage, false, false, default404ErrorMessage)
    }
  }


  static handleActionDialogSubmit(action, data, id, setFormLoading, FormikActions, defaultErrorMessage = '', default401ErrorMessage = '') {
    return RestClient.putRequest(formatRoute(Admin_EndPoints.invoices.actions[action], { uuid: id }), data, null, setFormLoading, null, FormikActions, defaultErrorMessage, default401ErrorMessage)
  }

  static getInvoiceData(id, defaultErrorMessage = '') {
    return RestClient.getRequest(formatRoute(Admin_EndPoints.invoices.details, { uuid: id }), null, defaultErrorMessage, true)
  }

  static getMsInvoiceData(id, defaultErrorMessage = '') {
    return RestClient.getRequest(formatRoute(Admin_EndPoints.invoices.msDetails, { uuid: id }), null, defaultErrorMessage, true)
  }

  static getSubmissionData(id, params, defaultErrorMessage = '') {
    let config = {}
    if (!!params && !!Object.keys(params).length) {
      config['params'] = params
    }
    return RestClient.getRequest(formatRoute(Admin_EndPoints.invoices.submission, { uuid: id }), config, defaultErrorMessage)
  }

  static getMsSubmissionData(id, params, defaultErrorMessage = '') {
    let config = {}
    if (!!params && !!Object.keys(params).length) {
      config['params'] = params
    }
    return RestClient.getRequest(formatRoute(Admin_EndPoints.invoices.msSubmission, { uuid: id }), config, defaultErrorMessage)
  }


  static getSingleEntity(entity, id, defaultErrorMessage = '') {
    let config = { headers: { 'Authorization': `Bearer ${CookiesStorageService.getAccessToken()}` } }
    return RestClient.getRequest(NamedRoutes.entities[entity].endpoint + `/${id}`, config, defaultErrorMessage)
  }

  static getCodeData(type, code, defaultErrorMessage = '') {
    return RestClient.getRequest(formatRoute(Admin_EndPoints.getCodeDetails, {
      type: type,
      code: code
    }), {}, defaultErrorMessage, true)
  }

  static handleDialogSubmit(entity, action, deleteLoading = null, FormikActions = null, data = {}, id = '', defaultErrorMessage = '', extraHeaders = '', default401ErrorMessage = '') {
    let config = !!extraHeaders ? { headers: extraHeaders } : {}
    switch (action) {
      case 'create':
        if (!!['codesUsageCreate'].includes(entity)) {
          return RestClient.putRequest(Admin_EndPoints[entity], data, config, FormikActions.setSubmitting, null, FormikActions, defaultErrorMessage, default401ErrorMessage)
        } else {
          return RestClient.postRequest(Admin_EndPoints[entity], data, config, FormikActions.setSubmitting, null, FormikActions, defaultErrorMessage, default401ErrorMessage)
        }
      case 'edit':
        let editEndpoint = Admin_EndPoints[entity] + `/${id}`
        if (!!['codeUsageEditEGS'].includes(entity)) {
          editEndpoint = formatRoute(Admin_EndPoints.getCodeDetails, {
            type: 'EGS',
            code: id
          })
        }
        if (!!['templates'].includes(entity)) {
          return RestClient.postRequest(Admin_EndPoints.saveTemplate, data, config, FormikActions.setSubmitting, null, FormikActions, defaultErrorMessage, default401ErrorMessage)
        } else {
          return RestClient.putRequest(editEndpoint, data, config, FormikActions.setSubmitting, null, FormikActions, defaultErrorMessage, default401ErrorMessage)
        }
      case 'delete':
      case 'bulk-delete':
        let deleteEndpoint = Admin_EndPoints[entity] + `/${id}`
        if (!!['drafts', 'templates'].includes(entity)) {
          deleteEndpoint = (entity === 'templates') ? Admin_EndPoints.deleteTemplate : Admin_EndPoints.deleteDraft
          return RestClient.postRequest(deleteEndpoint, data, config, deleteLoading, null, null, defaultErrorMessage)
        } else {
          return RestClient.deleteRequest(deleteEndpoint, config, deleteLoading, null, null, defaultErrorMessage, default401ErrorMessage)
        }
      default:
        break
    }
  }

  static getDownloadData(entity, id, setProgress, defaultErrorMessage = '') {
    if (!!id) {
      let config = {
        responseType: 'blob', // important
        onDownloadProgress: (progressEvent) => {
          setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total)) // you can use this to show user percentage of file downloaded
        }
      }
      return RestClient.getRequest(Admin_EndPoints[entity] + `/${id}`, config, defaultErrorMessage)
    }
  }

  static getSavedInvoiceEntityData(id, type, defaultErrorMessage = '') {
    let endpoint = ''
    switch (type) {
      case 'template':
        endpoint = Admin_EndPoints.singleTemplate
        break
      case 'draft':
        endpoint = Admin_EndPoints.singleDraft
        break
      case 'invoice':
        endpoint = formatRoute(Admin_EndPoints.invoices.msDetails, { uuid: id })
        break
      default:
        endpoint = Admin_EndPoints.singleDraft
    }
    return RestClient.getRequest(endpoint, (type === 'invoice') ? null : { params: { id: id } }, defaultErrorMessage)
  }


  static getDashboardData(data, setFormLoading, defaultErrorMessage = '') {
    return RestClient.postRequest(Admin_EndPoints.dashboard, data, null, setFormLoading, null, null, defaultErrorMessage)
  }

  static getSPConfigData(defaultErrorMessage = '') {
    return RestClient.getRequest(Admin_EndPoints.getSPConfig, null, defaultErrorMessage)
  }

  static getLateSubmissionReasons(defaultErrorMessage = '') {
    return RestClient.getRequest(Admin_EndPoints.getLateSubmissionReasons, null, defaultErrorMessage)
  }


}

export default ListingServices
